<template>
  <button :class="[disabled ? 'disabled' : '', 'maf-btn']" :disabled="disabled" :style="btnStyle" @click.stop="actionFunc" v-html="name"></button>
</template>

<script>
export default {
  name: 'MafButton',
  computed: {
    btnStyle() {
      return `
        width: ${this.width}px;
        min-width: ${this.minWidth}px;
        height: ${this.height}px;
        background: ${this.bgColor};
        font-size: ${this.fontSize}px;
        color: ${this.fontColor};
        text-transform: ${this.textTransform}
      `;
    }
  },
  props: {
    name: {
      type: String,
      default() {
        return '';
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    width: {
      type: Number,
      default() {
        return 247;
      }
    },
    minWidth: {
      type: Number,
      default() {
        return 0;
      }
    },
    height: {
      type: Number,
      default() {
        return 39;
      }
    },
    bgColor: {
      type: String,
      default() {
        return '-webkit-linear-gradient(left top, #FF790E, #FF5858)';
      }
    },
    fontColor: {
      type: String,
      default() {
        return '#fff';
      }
    },
    fontSize: {
      type: Number,
      default() {
        return 16;
      }
    },
    textTransform: {
      type: String,
      default() {
        return 'none';
      }
    }
  },
  methods: {
    actionFunc() {
      return this.$emit('actionFunc');
    }
  }
};
</script>

<style scoped lang="scss">
@import './../../sass/flex-layout.scss';

.maf-btn {
  @include inline-flex-row;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  transition: background-color 200ms linear;
  border: 0;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    color: #878787 !important;;
    background: #e8eaec !important;;
    cursor: default;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MafButton.vue